<script>

    import { toast } from 'bulma-toast'

    import { PackagesStore, UserStore } from '../stores'
    import PackagesService from '../$services/packages.service'

    import InputNumber from '../$components/input.number.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Select from '../$components/select.svelte'

    export let ipackage = {value: 0}

    let loading = false
    let insurance = 'false'

    if ($UserStore)
        getPackages()

    async function getPackages() {

        loading = true
        const resp = await PackagesService.getPackages()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        PackagesStore.set(resp.data.packages)
    }

    function onSelected(event) {
        const packageId = event.detail
        ipackage = $PackagesStore.find(item => item._id === packageId)
    }

</script>

<Spinner {loading} />

{#if $PackagesStore.length}
    <div class="columns">
        <div class="column">
            <Select on:change={ onSelected } required={false}
                label="Mis paquetes"
                icon="box-open"
                options={$PackagesStore.map(ipackage => {
                    return {
                        value: ipackage._id,
                        text: ipackage.alias
                    }
                })}
            />
        </div>
    </div>
{/if}
<div class="columns">
    <div class="column">
        <InputNumber bind:value={ipackage.width} label="Ancho" icon="ruler-horizontal" placeholder="CM" />
    </div>
    <div class="column">
        <InputNumber bind:value={ipackage.height} label="Alto" icon="ruler-vertical" placeholder="CM" />
    </div>
    <div class="column">
        <InputNumber bind:value={ipackage.length} label="Largo" icon="ruler" placeholder="CM" />
    </div>
</div>
<div class="columns">
    <div class="column is-4">
        <InputNumber bind:value={ipackage.weight} label="Peso" icon="weight" placeholder="KG" />
    </div>
    <div class="column">
        <Select bind:value={insurance} label="Asegurar" icon="dollar-sign"
            options={[
                {value: 'false', text: 'NO'},
                {value: 'true', text: 'SI'},
            ]}
        />
    </div>
    {#if insurance === 'true'}
        <div class="column">
            <InputNumber bind:value={ipackage.value} label="Valor del contenido" icon="dollar-sign" placeholder="MXN" />
        </div>
    {/if}
</div>